import { Currency, ETHER, Token } from 'apertum-dex-sdk'

export function currencyId(currency: Currency): string {
  if (currency === ETHER) return 'APTM'
  if (currency instanceof Token) return currency.address
  throw new Error('invalid currency')
}
